import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-validacao-form-input',
  templateUrl: './validacao-form-input.component.html',
  styleUrls: ['./validacao-form-input.component.scss']
})
export class ValidacaoFormInputComponent implements OnInit {
  @Input() nomeFormulario!: AbstractControl;
  @Input() nomeCampo: string = '';
  @Input() maxLength!: number;
  @Input() minLength!: number;
  @Input() isFormSubmited: boolean = false;
  @Input() campoTocado: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }
  verificarComprimento() {
    const valorCampo = this.nomeFormulario.get(this.nomeCampo)?.value;
    if (valorCampo && valorCampo.length > this.maxLength) {
      this.nomeFormulario.get(this.nomeCampo)?.setErrors({ 'maxlength': true });
    } else {
      this.nomeFormulario.get(this.nomeCampo)?.setErrors(null);
    }
  }

}
